import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getMtrApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'MTR_SORT_KEY_TOO_LONG') {
    return data?.message || '排序鍵最多 100 字';
  }

  if (code === 'MTR_NOT_FOUND') {
    return data?.message || '找不到物料資料';
  }

  if (code === 'MTR_TEMPLATE_REQUIRED_SPEC_MISSING') {
    return data?.message || '必填規格未填完整';
  }

  if (code === 'BOM_NOT_FOUND') {
    return data?.message || '找不到要關聯的 BOM';
  }

  if (code === 'BOM_INACTIVE') {
    return data?.message || '只能關聯啟用中的 BOM';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'MTR_SN_MAPPING_IDS_REQUIRED') {
    return data?.message || '缺少物料序號清單';
  }

  if (code === 'MTR_SN_MAPPING_ID_REQUIRED') {
    return data?.message || '物料序號清單含有空值';
  }

  if (code === 'MTR_SN_MAPPING_DUPLICATED') {
    return data?.message || '物料序號重複選取';
  }

  if (code === 'MTR_SN_MAPPING_NOT_FOUND') {
    return data?.message || '有物料序號已不存在，請重新選擇';
  }

  if (code === 'MTR_SN_MAPPING_NOT_ACTIVE') {
    return data?.message || '新加入的物料序號不是啟用中，請重新選擇';
  }

  if (code === 'MTR_UNIT_NOT_FOUND') {
    return data?.message || '找不到物料單位';
  }

  if (code === 'MTR_UNIT_DEACTIVATE_REFERENCED') {
    return data?.message || '此單位已被業務資料引用，無法停用';
  }

  if (code === 'MTR_UNIT_LEGACY_UNIT_ID_NOT_ALLOWED') {
    return data?.message || '此單位資料格式已更新，請改用英文縮寫與名稱';
  }

  if (code === 'MTR_UNIT_CREATE_FIELD_NOT_ALLOWED') {
    return data?.message || '建立物料單位含有不允許的欄位';
  }

  if (code === 'MTR_BASE_UNIT_IMMUTABLE' || code === 'MTR_BASE_UNIT_ID_IMMUTABLE') {
    return data?.message || '基準單位不可變更或清空';
  }

  if (code === 'MTR_DEFAULT_DISPLAY_UNIT_REQUIRED') {
    return data?.message || '請選擇預設顯示單位';
  }

  if (code === 'MTR_GROUP_DEFAULT_DISPLAY_UNIT_NOT_ALLOWED') {
    return data?.message || '組合物料不可設定預設顯示單位';
  }

  if (code === 'MTR_DEFAULT_DISPLAY_UNIT_CONVERT_REQUIRED') {
    return data?.message || '選擇進位單位為預設前，請先設定進位單位';
  }

  if (error?.response?.status === 400 && data?.message) {
    return data.message;
  }

  if (error?.response?.status === 409 && data?.message) {
    return data.message;
  }

  return data?.message || fallback;
}

/** 後端欄位錯誤 → 表單欄位（目前僅 sort_key） */
export function getMtrApiErrorField(error) {
  const data = error?.response?.data;
  if (data?.code === 'MTR_SORT_KEY_TOO_LONG' || data?.field === 'sort_key') {
    return 'sortKey';
  }
  return null;
}

export function isMtrVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}

export function shouldReloadMtrSnMappings(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.code;
  return status === 409
    || code === 'MTR_SN_MAPPING_NOT_FOUND'
    || code === 'MTR_NOT_FOUND';
}
